module.exports = [
	[/Critical dependencies/]
];